import { React, useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";

import {
  companyLocationCreation,
  getCompanyAddressData,
  companyLocationUpdation,
  fetchUserData,
  setUser,
} from "../../redux/actions";
import { useNavigate, useParams } from "react-router-dom";

const CompanyActions = ({ pageData: initialData }) => {
  const region = useSelector((state) => state?.region?.region);

  const { id } = useParams();
  // const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  //const [isOpen, setIsOpen] = useState(null);
  const [pageData, setPageData] = useState({
    name: "",
    recipient: "",
    city: "",
    deliveryAddress: {
      city: "",
      country: "",
      street: "",
      email: "",
      landline: "",
    },
  });

  const [formData, setFormData] = useState({
    name: "",
    recipient: "",
    city: "",
    country: region,
    street: "",
    email: "",
    landline: "", // Store checkboxes as an array
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleSubmit = async (event) => {
    event.preventDefault(); // Prevent page reload
    const formData = new FormData(event.target);

    // Convert FormData to an object and log it
    const data = Object.fromEntries(formData.entries());

    if (data.location_id) {
      const response = await companyLocationUpdation(data);
      if (response) {
        const user_updated_data = await fetchUserData();
        if (user_updated_data) {
          dispatch(setUser(user_updated_data));
        }
        toast.success("Location updated successfully!");
        setTimeout(() => {
          navigate("/self-service/mycompany", {
            state: { callFunction: true },
          });
        }, 2000);
      }
    } else {
      if (
        typeof data?.landline === "string" &&
        data?.landline?.length !== 8 &&
        data?.landline?.length !== 9
      ) {
        toast.error("Phone number must be exactly 8 or 9 digits!");
        return false;
      }
      const response = await companyLocationCreation(data);
      if (response) {
        const user = await fetchUserData();
        if (user) {
          dispatch(setUser(user));
        }
        toast.success("Location added successfully!");

        setTimeout(() => {
          navigate("/self-service/mycompany");
        }, 2000);
      }
    }
  };

  // Handle text input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const hasFetched = useRef(false);

  const getAddressData = async (id) => {
    try {
      const result = await getCompanyAddressData(id);

      if (result?.page?.data?.location) {
        setPageData(result?.page?.data?.location);
      } else {
        setError("User data not found");
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      setError("Error fetching page data");
    } finally {
      //setLoading(false);
    }
  };

  useEffect(() => {
    if (pageData) {
      setFormData({
        name: pageData?.name ?? "",
        recipient: pageData?.recipient ?? "",
        city: pageData?.delivery_address?.city ?? "",
        country: pageData?.delivery_address?.country ?? "",
        street: pageData?.delivery_address?.street ?? "",
        email: pageData?.delivery_address?.email ?? "",
        landline: pageData?.delivery_address?.landline ?? "",
      });
    }
  }, [pageData]); //pageData

  useEffect(() => {
    if (id && !hasFetched.current) {
      getAddressData(id);
      hasFetched.current = true; // Prevents future calls
    }
  }, [id]);

  return (
    <form onSubmit={handleSubmit} method="post">
      <div className="page-container">
        {/* Header */}
        <section className="hot-deals pt-20">
          <div className="container container-lg">
            <div className="section-heading">
              <div className="d-flex align-items-center justify-content-between flex-wrap gap-8">
                <h2 className="mb-0 text-blue">DELIVERY ADDRESS</h2>
                <button
                  className="btn bg-main-product-50 hover-bg-main-product-50 hover-text-white text-nowrap mt-2"
                  type="button"
                  onClick={() => navigate("/self-service/mycompany/")}
                >
                  X
                </button>
              </div>
            </div>
          </div>

          {/* Scrollable Body */}
          <div className="scrollable-body">
            <div className="container container-lg">
              <div className="center row gy-4">
                <div className="col-sm-6">
                  <div className="border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 offer-card position-relative overflow-hidden p-16">
                    <div className="py-xl-4">
                      <div className="d-flex flex-column gap-3">
                        <div className="d-flex align-items-center gap-2">
                          <label
                            htmlFor="name"
                            className="lable-font font-heading-two text-gray-900 fw-semibold mb-0"
                            style={{ minWidth: "120px" }}
                          >
                            Address name *
                          </label>
                          <input
                            type="text"
                            className="input-font common-input px-16 flex-grow-1"
                            id="name"
                            name="name"
                            placeholder="Address"
                            value={formData?.name}
                            onChange={handleInputChange}
                            required
                          />
                        </div>

                        <p>
                          The new user will get an invite e-mail. He/she will
                          have to create a password and can start exercising
                          their new rights straight after that.
                        </p>
                        <br />
                        <h3 className="center text-blue">Address</h3>
                        <hr />
                        <div className="d-flex align-items-center gap-2">
                          <label
                            htmlFor="phone"
                            className="lable-font font-heading-two text-gray-900 fw-semibold mb-0"
                            style={{ minWidth: "120px" }}
                          >
                            Country
                          </label>
                          <div className="d-flex align-items-center gap-2 flex-grow-1">
                            <input
                              type="text"
                              className="input-font common-input"
                              name="country"
                              id="country"
                              value={formData?.country || region || ""}
                              readOnly
                            />
                          </div>
                        </div>
                        <hr />
                        <div className="d-flex align-items-center gap-2">
                          <label
                            htmlFor="city"
                            className="lable-font font-heading-two text-gray-900 fw-semibold mb-0"
                            style={{ minWidth: "120px" }}
                          >
                            City *
                          </label>
                          <input
                            type="text"
                            className="input-font common-input px-16 flex-grow-1"
                            id="city"
                            name="city"
                            placeholder="City"
                            value={formData?.city}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                        <hr />
                        <div className="d-flex align-items-center gap-2">
                          <label
                            htmlFor="street"
                            className="lable-font  font-heading-two text-gray-900 fw-semibold mb-0"
                            style={{ minWidth: "120px" }}
                          >
                            Street *
                          </label>
                          <input
                            type="text"
                            className="input-font common-input px-16 flex-grow-1"
                            id="street"
                            name="street"
                            placeholder="Street"
                            value={formData?.street}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                        <br />
                        <h3 className="center text-blue">Contact person</h3>
                        <hr />
                        <div className="d-flex align-items-center gap-2">
                          <label
                            htmlFor="recipient"
                            className="lable-font  font-heading-two text-gray-900 fw-semibold mb-0"
                            style={{ minWidth: "120px" }}
                          >
                            Recipient *
                          </label>
                          <input
                            type="text"
                            className="input-font common-input px-16 flex-grow-1"
                            id="recipient"
                            name="recipient"
                            placeholder="Recipient"
                            value={formData?.recipient}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                        <hr />
                        <div className="d-flex align-items-center gap-2">
                          <label
                            htmlFor="phone_no"
                            className="lable-font  font-heading-two text-gray-900 fw-semibold mb-0"
                            style={{ minWidth: "120px" }}
                          >
                            Phone number *
                          </label>
                          <input
                            type="text"
                            className="input-font common-input px-16 flex-grow-1"
                            id="landline"
                            name="landline"
                            placeholder="Phone number"
                            value={formData?.landline}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                        <hr />
                        <div className="d-flex align-items-center gap-2">
                          <label
                            htmlFor="email"
                            className="lable-font  font-heading-two text-gray-900 fw-semibold mb-0"
                            style={{ minWidth: "120px" }}
                          >
                            Email *
                          </label>
                          <input
                            type="text"
                            className="input-font common-input px-16 flex-grow-1"
                            id="email"
                            name="email"
                            placeholder="Email"
                            value={formData?.email}
                            onChange={handleInputChange}
                            required
                          />
                          <input
                            type="hidden"
                            name="location_id"
                            value={pageData?.id}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Fixed Footer */}
          <div className="fixed-footer">
            <button
              className="btn pending_btn"
              type="button"
              onClick={() => navigate("/self-service/mycompany/")}
            >
              Cancel
            </button>
            <button
              className="btn bg-main-product-50 hover-bg-main-product-50 hover-text-white text-nowrap mt-2"
              type="submit"
            >
              Save Changes
            </button>
          </div>
        </section>
      </div>
    </form>
  );
};

export default CompanyActions;
